import { Checkbox, TableCell, TableRow } from '@mui/material';
import { formatSwedishDateTime } from '../../../common/lib/formatSwedishDateTime';
import { createAdressLine } from '../../lib/createAdressLine';
import { BostadsvarderingDto } from '../../types/dtos/VarderingarModel';

interface SavedVarderingarTableRowProps {
  selectBostadsvardering: (bostadsvardering: BostadsvarderingDto) => void;
  handleCheckboxClick: (bostadsvardering: BostadsvarderingDto) => void;
  rowData: BostadsvarderingDto;
  isItemSelected: boolean;
  isItemActive: boolean;
}

export const SavedVarderingarTableRow: React.FC<
  SavedVarderingarTableRowProps
> = ({
  selectBostadsvardering,
  handleCheckboxClick,
  rowData,
  isItemSelected,
  isItemActive,
}) => (
  <TableRow
    hover
    role="checkbox"
    onClick={() => selectBostadsvardering(rowData)}
    tabIndex={-1}
    key={rowData.id}
    selected={isItemActive}
    sx={{
      cursor: 'default',
    }}
  >
    <TableCell padding="checkbox">
      <Checkbox
        color="primary"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleCheckboxClick(rowData);
        }}
        checked={isItemSelected}
      />
    </TableCell>
    <TableCell>{createAdressLine(rowData.adress)}</TableCell>
    <TableCell>{formatSwedishDateTime(rowData.uppdateradTidpunkt)}</TableCell>
    <TableCell>{rowData.kundmarke}</TableCell>
  </TableRow>
);
